import { takeLatest } from 'redux-saga/effects';
import {
  getPayrollListSuccess, getPayrollListFail,
  getPayrollDetailsSuccess, getPayrollDetailsFail
} from './payrollState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/finance/payrolls');
const redirectData = {route:'console/payrolls', mode: 'list', recordId:0 };
const modelName = 'Payroll';
const modelId = 'pay_id';

function* getPayrollList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getPayrollListSuccess, 
		getPayrollListFail,
		null, null, LOADING_MSG);
}

function* getPayrollDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getPayrollDetailsSuccess, 
		getPayrollDetailsFail,
		null, null, LOADING_MSG);  	
}

function* doPayrollCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getPayrollDetailsSuccess, 
		getPayrollDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: 'reload'},
		SAVING_MSG);	
}

function* doPayrollUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getPayrollDetailsSuccess, 
		getPayrollDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: 'reload'}, 
		UPDATING_MSG);	
}

function* doPayrollDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getPayrollDetailsSuccess, 
		getPayrollDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* doPayrollProgressUpdate(data){
	
	console.log(data.payload);	
	const { payrollId, process } = data.payload;
	
	yield doCrudCall(
		() => crudService.doPostRequest(`${payrollId}/progress/update/${process}`, null), 
		getPayrollDetailsSuccess, 
		getPayrollDetailsFail,
		updateRecordSuccess(modelName),
		process === 'payreg validated' ? null : {...redirectData, mode: 'reload'},
		UPDATING_MSG);	
}

function* payrollSaga() {
  	yield takeLatest('payroll/getPayrollList', getPayrollList);
  	yield takeLatest('payroll/getPayrollDetails', getPayrollDetails);
  	yield takeLatest('payroll/doPayrollCreate', doPayrollCreate);
  	yield takeLatest('payroll/doPayrollUpdate', doPayrollUpdate);
  	yield takeLatest('payroll/doPayrollDelete', doPayrollDelete);  
  	yield takeLatest('payroll/doPayrollProgressUpdate', doPayrollProgressUpdate);
}

export default payrollSaga;
